import { createApi } from '@reduxjs/toolkit/query/react';

import { OperatorShape, OperatorsResponseShape } from 'models/operator';
import { baseQuery } from '..';

export const OperatorsApi = createApi({
  reducerPath: 'operatorsApi',
  tagTypes: ['operators', 'operator'],
  baseQuery,
  endpoints: (builder) => ({
    getOperatorsTableData: builder.query<OperatorsResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['operators'],
    }),
    getOperator: builder.query<OperatorShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['operator'],
    }),
  }),
});

export const { useGetOperatorsTableDataQuery, useGetOperatorQuery } =
  OperatorsApi;
